import axios from 'axios';
import { isNull, pick } from 'lodash';
import LogRocket from 'logrocket';

import theme from '../themes';
import { apiHost } from './api-host';

let logRocketRecordingURL;
LogRocket.getSessionURL((sessionURL) => {
  logRocketRecordingURL = sessionURL;
});

/* eslint quote-props: 0 */
export const axiosInstance = axios.create({
  baseURL: `${apiHost}/v1`,
  timeout: 600000, // Are 10 minutes too much?
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Gustav-Platform-Domain': theme.domain,
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const AUTH_TOKEN = localStorage.getItem('phoenixAuthToken');
    const EXP_TOKEN = localStorage.getItem('phoenixExpToken');

    /* eslint security/detect-unsafe-regex: 0 */
    const isExternalUrl = /^(?:[a-z]+:)?\/\//.test(config.url); // universal, non case-sensitive, protocol-agnostic
    // Remove all headers when requesting 3rd party APIs
    if (isExternalUrl) {
      return { ...config, headers: pick(config.headers, 'Content-Type') };
    }

    // Append authorization header if jwt token is available in localStorage
    if (!isNull(AUTH_TOKEN)) {
      return {
        ...config,
        headers: {
          ...config.headers,
          'X-LogRocket-URL': logRocketRecordingURL,
          'Authorization-Exp': EXP_TOKEN,
          Authorization: AUTH_TOKEN,
        },
      };
    }

    // Return default config
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    const EXP_TOKEN = response.headers['authorization-exp'];

    if (EXP_TOKEN) {
      localStorage.setItem('phoenixExpToken', EXP_TOKEN);
    }

    return response;
  },
  (error) => Promise.reject(error)
);
